import React, { useState, useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./AddProductForm.css";
import Layout from "../../components/layout";

const AddProductForm = () => {
  const [formData, setFormData] = useState({
    category: "",
    title: "",
    menge: "",
    preis: "",
    inhaltstoffe: [],
    newCategory: "",
  });
  const [categories, setCategories] = useState([]);
  const [useNewCategory, setUseNewCategory] = useState(false);
  const [errors, setErrors] = useState({});

  const inhaltstoffeOptions = [
    { id: 1, label: "1: Farbstoff" },
    { id: 2, label: "2: Taurin" },
    { id: 3, label: "3: Antioxidationsmittel" },
    { id: 4, label: "4: Chininhaltig" },
    { id: 5, label: "5: Koffein" },
  ];

  const fetchCategories = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/categories`
      );
      const data = await response.json();
      setCategories(data);
    } catch (error) {
      toast.error("Fehler beim Abrufen der Kategorien.");
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleCategoryToggle = () => {
    setUseNewCategory(!useNewCategory);
    setFormData({ ...formData, newCategory: "", category: "" });
  };

  const handleInhaltstoffeChange = (id) => {
    const updatedInhaltstoffe = formData.inhaltstoffe.includes(id)
      ? formData.inhaltstoffe.filter((item) => item !== id)
      : [...formData.inhaltstoffe, id];
    setFormData({ ...formData, inhaltstoffe: updatedInhaltstoffe });
  };

  const validateForm = () => {
    const { category, title, preis, newCategory } = formData;
    const newErrors = {};

    if (!useNewCategory && !category) {
      newErrors.category = "Bitte eine Kategorie auswählen.";
    } else if (useNewCategory && !newCategory) {
      newErrors.newCategory = "Bitte eine neue Kategorie eingeben.";
    }

    if (!title) {
      newErrors.title = "Titel ist ein Pflichtfeld.";
    }

    if (!preis) {
      newErrors.preis = "Preis ist ein Pflichtfeld.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) {
      toast.error("Bitte fülle alle Pflichtfelder aus.");
      return;
    }

    const { title, menge, preis, newCategory, category, inhaltstoffe } =
      formData;
    const selectedCategory = useNewCategory ? newCategory : category;
    const mengeValue = menge ? menge : " ";
    const inhaltstoffeString =
      inhaltstoffe.length > 0 ? inhaltstoffe.join(",") : null;

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/getraenke`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            category: selectedCategory,
            title,
            menge: mengeValue,
            preis,
            inhaltstoffe: inhaltstoffeString,
          }),
        }
      );

      if (!response.ok) {
        throw new Error(`Fehler: ${response.status}`);
      }

      const data = await response.json();
      toast.success(`Produkt erfolgreich hinzugefügt: ${data.title}`);
      setFormData({
        category: "",
        title: "",
        menge: "",
        preis: "",
        inhaltstoffe: [],
        newCategory: "",
      });
      setErrors({});
    } catch (error) {
      console.error("Fehler beim Hinzufügen des Produkts:", error);
      toast.error("Fehler beim Hinzufügen des Produkts.");
    }
  };

  useEffect(() => {
    fetchCategories();
  }, []);

  return (
    <Layout>
      <div className="Bottom Bottom12">
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={true}
          newestOnTop={true}
          closeOnClick
          pauseOnHover
          limit={1}
          style={{ width: "250px", fontSize: "14px" }}
        />
        <div className="add-product-form">
          <h2>Neues Produkt hinzufügen</h2>
          <form onSubmit={handleSubmit}>
            {/* Kategorie Auswahl */}
            <div className="form-group">
              <label><h4>Kategorie:</h4></label>
              {useNewCategory ? (
                <input
                  type="text"
                  name="newCategory"
                  value={formData.newCategory}
                  onChange={handleChange}
                  placeholder="Neue Kategorie eingeben"
                  required
                />
              ) : (
                <select
                  name="category"
                  value={formData.category}
                  onChange={handleChange}
                  required
                >
                  <option value="">Kategorie auswählen</option>
                  {categories.map((category, index) => (
                    <option key={index} value={category}>
                      {category.charAt(0).toUpperCase() + category.slice(1)}
                    </option>
                  ))}
                </select>
              )}
              {errors.category && (
                <p className="error-message">{errors.category}</p>
              )}
              {errors.newCategory && (
                <p className="error-message">{errors.newCategory}</p>
              )}
              <button
                type="button"
                className="toggl-button"
                onClick={handleCategoryToggle}
              >
                {useNewCategory
                  ? "Bestehende Kategorie verwenden"
                  : "Neue Kategorie eingeben"}
              </button>
            </div>

            {/* Titel */}
            <div className="form-group">
              <label><h4>Titel:</h4></label>
              <input
                type="text"
                name="title"
                value={formData.title}
                onChange={handleChange}
                required
              />
              {errors.title && <p className="error-message">{errors.title}</p>}
            </div>

            {/* Menge */}
            <div className="form-group">
              <label><h4>Menge (Optional):</h4></label>
              <input
                type="text"
                name="menge"
                value={formData.menge}
                onChange={handleChange}
                placeholder="Optional"
              />
            </div>

            {/* Preis */}
            <div className="form-group">
              <label><h4>Preis:</h4></label>
              <input
                type="number"
                step="0.01"
                name="preis"
                value={formData.preis}
                onChange={handleChange}
                required
              />
              {errors.preis && <p className="error-message">{errors.preis}</p>}
            </div>

            {/* Inhaltsstoffe als Checkboxen */}
            <div className="form-group">
              <label><h4>Inhaltsstoffe:</h4></label>
              <div className="checkbox-group">
                {inhaltstoffeOptions.map((option) => (
                  <div key={option.id} className="checkbox-row">
                    <span>{option.label}</span>
                    <input
                      type="checkbox"
                      value={option.id}
                      checked={formData.inhaltstoffe.includes(option.id)}
                      onChange={() => handleInhaltstoffeChange(option.id)}
                    />
                  </div>
                ))}
              </div>
            </div>

            <button type="submit" className="submi-button">
              Produkt hinzufügen
            </button>
          </form>
        </div>
      </div>
    </Layout>
  );
};

export default AddProductForm;
